<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-capitalize">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active text-capitalize"><i class="fas fa-object-group"></i> {{ this.$route.name }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <input class="btn btn-primary" type="button" value="New site group" @click="showCreateForm">&nbsp;&nbsp;
          </div>
        </div>

        <data-table-wrapper
            ref="siteGroupsTable"
            :columns="columns"
            :filters="filters"
            endpoint="/sitegroup"
            sort-column-default="id"
            sort-order-default="asc"
            v-on:edit-request="this.showEditForm"
            :disable-delete-action="true"
        ></data-table-wrapper>
      </div>

      <edit-site-group
          v-if="editSiteGroup"
          :item="editSiteGroup"
          :mode="editMode"
          v-on:close="this.hideEditForm"
          v-on:finish="this.loadData"
      ></edit-site-group>

    </section>
  </div>
</template>

<script>
import EditSiteGroup from '../components/EditSiteGroup';
import DataTableWrapper from '../components/DataTableWrapper';

export default {
  components: {
    EditSiteGroup,
    DataTableWrapper,
  },
  data() {
    return {
      editMode: null,
      editSiteGroup: null,
      columns: [
        {
          field: 'name',
          title: 'Name',
          sorting: true,
          filterEnabled: true,
        }
      ],
      filters: [
        {
          field: 'name',
          placeholder: 'Enter name',
          label: 'Name',
        }
      ]
    };
  },
  methods: {
    showCreateForm() {
      let data = {
        id: '',
        name: ''
      };

      this.editMode = 'create';
      this.editSiteGroup = data;
    },
    showEditForm(data) {
      this.editMode = 'edit';
      this.editSiteGroup = {...data};
    },
    hideEditForm() {
      this.editMode = null;
      this.editSiteGroup = null;
    },
    loadData() {
      this.$refs.siteGroupsTable.loadData();
    },
  },
  mounted() {
  },
};
</script>